// StatsBar.jsx
import './StatsBar.css';
const STATS = [
  { n:'883+', l:'Assessments Created' },
  { n:'199+', l:'Total Applicants' },
  { n:'49%',  l:'Average Pass Rate' },
  { n:'36',   l:'Active Job Postings' },
];
export default function StatsBar() {
  return (
    <div className="stats-bar">
      {STATS.map(s=>(
        <div key={s.l} className="stat">
          <div className="stat__n">{s.n}</div>
          <div className="stat__l">{s.l}</div>
        </div>
      ))}
    </div>
  );
}
